export default function(x) {
  return (x * x * x * (35 / 3072));
}


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/proj4/lib/common/e3fn.js
// module id = ../../../../proj4/lib/common/e3fn.js
// module chunks = vendor